/* GRIPT Black Friday 2026: giveaway promo (turns itself off after Nov 27, 11:59 PM ET) */
(() => {
  const END = Date.parse('2026-11-28T04:59:59Z');
  if (Date.now() > END) return;
  const URL_ = '/pages/giveaway';
  const onGiveaway = location.pathname.replace(/\/$/, '') === URL_;
  const $ = (s, el = document) => el.querySelector(s);
  const money = n => '$' + n.toFixed(2);
  const gift = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" aria-hidden="true"><rect x="3" y="8" width="18" height="4" rx="1"/><path d="M5 12v9h14v-9M12 8v13M12 8S10.5 3 7.5 4.5 9 8 12 8Zm0 0s1.5-5 4.5-3.5S15 8 12 8Z"/></svg>';
  const arrow = '<svg class="arr" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M4 12h15M13 6l6 6-6 6"/></svg>';

  const run = () => {
    const G = window.GRIPT || {};
    const imgOf = (h, w) => { const p = G.byHandle && G.byHandle[h]; return p && p.images[0] && G.img ? G.img(p.images[0], w) : ''; };

    /* announcement bar */
    const tr = $('.announce__track');
    if (tr) {
      const items = `<span><a href="${URL_}">Black Friday giveaway: every $10 = 1 entry</a></span><span>Win $148 in GRIPT gear · 4 winners</span><span><a href="${URL_}">Share our giveaway post to your IG story = +1 entry</a></span><span>Free shipping on orders $18+</span>`;
      tr.innerHTML = Array(8).fill(items).join('');
    }

    /* main menu (desktop + mobile) and footer */
    const nav = $('.hdr__nav');
    if (nav) nav.insertAdjacentHTML('beforeend', `<a href="${URL_}" ${onGiveaway ? 'aria-current="page"' : ''}>Giveaway<span class="tag">WIN</span></a>`);
    if (onGiveaway) { const sup = $('.hdr__nav a[href="/pages/contact"]'); if (sup) sup.removeAttribute('aria-current'); }
    const mn = $('#mnav ul');
    if (mn) mn.insertAdjacentHTML('afterbegin', `<li><a href="${URL_}">Giveaway <span>Win $148</span></a></li>`);
    const h = [...document.querySelectorAll('.ftr h4')].find(x => x.textContent.trim() === 'GRIPT');
    if (h && h.nextElementSibling) h.nextElementSibling.insertAdjacentHTML('afterbegin', `<li><a href="${URL_}">Black Friday giveaway</a></li>`);

    /* homepage: hero badge + banner right under the hero */
    const chip = $('#heroChip');
    if (chip) {
      chip.href = URL_;
      chip.innerHTML = `<img src="${imgOf('essentials-gym-bundle', 200)}" alt=""><div><small>Black Friday giveaway</small><b>Win $148 in GRIPT gear</b><span>Every $10 spent = 1 entry</span></div>`;
    }
    const hero = $('#hero');
    if (hero) {
      const prizes = ['essentials-gym-bundle', 'essential-oversized-boxy-fit-fleece-hoodie-1', 'magnetic-gym-bag', 'palm-protectors'];
      hero.insertAdjacentHTML('afterend', `
        <section class="gbf-band">
          <div class="wrap gbf-band__in">
            <div class="gbf-band__thumbs">${prizes.map(p => `<img src="${imgOf(p, 160)}" alt="" loading="lazy">`).join('')}</div>
            <div class="gbf-band__txt">
              <span class="kicker"><b>●</b> Black Friday giveaway · ends Nov 27</span>
              <h2 class="display">Win $148 in <span class="accent">GRIPT gear.</span></h2>
              <p>Every $10 you spend = 1 entry. Share our giveaway graphic to your Instagram story for +1 more. 4 winners. No purchase necessary.</p>
            </div>
            <a class="btn btn-accent" href="${URL_}" data-magnetic>See the prizes ${arrow}</a>
          </div>
        </section>`);
    }

    /* product page: entries next to Add to bag */
    const buy = $('#buy');
    if (buy) {
      const paintPdp = () => {
        const row = $('.buy__row', buy);
        if (!row || $('.gbf-pdp', buy)) return;
        const btn = $('#addBtn', buy);
        const m = btn && btn.textContent.match(/\$([0-9.,]+)/);
        if (!m) return;
        const cents = Math.round(parseFloat(m[1].replace(/,/g, '')) * 100);
        const n = Math.floor(cents / 1000);
        const txt = n
          ? `This earns you <b>${n} giveaway entr${n === 1 ? 'y' : 'ies'}</b> to win $148 in GRIPT gear.`
          : `Spend $10 to earn a <b>giveaway entry</b> to win $148 in GRIPT gear.`;
        row.insertAdjacentHTML('afterend', `<a class="gbf-pdp" href="${URL_}">${gift}<span>${txt}</span><i>Details</i></a>`);
      };
      new MutationObserver(paintPdp).observe(buy, { childList: true });
      paintPdp();
      if ($('#matb')) document.body.classList.add('gbf-raise');
    }

    /* floating button on every page (can be closed for the visit) */
    let closed = false;
    try { closed = sessionStorage.getItem('gbf-float') === '0'; } catch (e) { /* storage unavailable */ }
    if (!onGiveaway && !closed) {
      document.body.insertAdjacentHTML('beforeend', `<div class="gbf-float"><a href="${URL_}">${gift}<span>Win $148 in gear</span></a><button type="button" aria-label="Hide giveaway button">×</button></div>`);
      $('.gbf-float button').addEventListener('click', e => {
        e.currentTarget.parentElement.remove();
        try { sessionStorage.setItem('gbf-float', '0'); } catch (err) { /* storage unavailable */ }
      });
    }

    /* cart drawer: entries so far */
    const ft = $('#dFt');
    if (!ft) return;
    const paint = () => {
      if ($('.gbf-entries', ft)) return;
      const b = $('.drawer__row b', ft);
      if (!b) return;
      const cents = Math.round((parseFloat(b.textContent.replace(/[^0-9.]/g, '')) || 0) * 100);
      const n = Math.floor(cents / 1000);
      const left = money((1000 - (cents % 1000)) / 100);
      const msg = n
        ? `You've earned <b>${n} giveaway entr${n === 1 ? 'y' : 'ies'}</b>. Add ${left} for ${n + 1}.`
        : `Add ${left} to earn your first <b>giveaway entry</b>.`;
      b.closest('.drawer__row').insertAdjacentHTML('afterend', `<a class="gbf-entries" href="${URL_}">${msg}</a>`);
    };
    new MutationObserver(paint).observe(ft, { childList: true });
    paint();
  };
  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', run) : run();
})();
